export default __webpack_public_path__ + "static/media/background-top-right-illustration.00779cca.svg";